<template>
  <div class="container-fluid py-4">
    <div class="row mb-4">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Materials</h4>
        <router-link to="/add-materiel">
          <button class="btn text-white" style="background-color: #b03a45;">+ Add Material</button>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 mt-n4 mx-3 z-index-2">
            <div class="shadow-success border-radius-lg pt-4 pb-3" style="background: linear-gradient(195deg, #b03a45, #8d2e38);">
              <h6 class="text-white ps-3">Materials Table</h6>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Reference</th>
                    <th>Serial Number</th>
                    <th>Type</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in materials" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.reference }}</td>
                    <td>{{ item.serialNumber }}</td>
                    <td>{{ item.type }}</td>
                    <td class="text-center">
                      <router-link :to="`/modifier-material/${item.id}`" class="text-primary me-3">
                        <i class="fas fa-edit"></i>
                      </router-link>
                      <a href="javascript:;" class="text-danger" @click="deleteMaterial(item.id)">
                        <i class="fas fa-trash-alt"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="materials.length === 0" class="text-center py-4 text-muted">No materials to show.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "materiall",
  data() {
    return {
      materials: [
        { id: 1, name: "Laptop", reference: "HP123", serialNumber: "SN001", type: "Electronics" },
        { id: 2, name: "Printer", reference: "CAN456", serialNumber: "SN002", type: "Office" }
      ]
    };
  },
  methods: {
    deleteMaterial(id) {
      this.materials = this.materials.filter(m => m.id !== id);
      alert("Material deleted.");
    }
  }
};
</script>
